import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class DigitalClockButton extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, x,y, frame, soundKey, clickCallback) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, frame);

    this.setInteractive();

    this._onClickCallback = clickCallback;
    this.soundKey = soundKey;

    this.isDown = false;
    this.isRepeating = false;
    this.lastFireTime = -1;

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this._onPointerDown, this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this._onPointerUp, this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this._onPointerUp, this);
    this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this._update, this);

    this.once(Phaser.GameObjects.Events.DESTROY, () => {
      this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this._onPointerDown, this);
      this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this._onPointerUp, this);
      this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this._onPointerUp, this);
      this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this._update, this);
    });
  }

  _onPointerDown() {
    this.isDown = true;
    this.isRepeating = false;
    this.lastFireTime = this.scene.time.now;
    ABCyaPhaser.Audio.playOneShot(this.soundKey, this.scene);
    this._onClickCallback();

    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 100, { scale: 0.8 }, Phaser.Math.Easing.Quadratic.Out);
  }

  _onPointerUp() {
    this.isDown = false;
    this.isRepeating = false;

    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 100, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  _update(time,delta) {
    if (this.isRepeating) {
      if (time - this.lastFireTime > 100) {
      // when repeating, fire every 0.1 seconds
        this.lastFireTime = time;
        ABCyaPhaser.Audio.playOneShot(this.soundKey, this.scene, 0.25);
        this._onClickCallback();
      }
    }
    else if (this.isDown) {
      // if down, but not yet repeating, waiting 0.5 seconds before starting repeat
      if (time - this.lastFireTime > 500) {
        this.isRepeating = true;
        this.lastFireTime = time;
        ABCyaPhaser.Audio.playOneShot(this.soundKey, this.scene, 0.5);
        this._onClickCallback();
      }
    }
  }
}